import type { SxProps } from "@mui/material";

const buttonsRowStyle: SxProps = {
  mb: 4,
  display: "flex",
  gap: 3,
  alignItems: "center",
};

const buttonAStyle: SxProps = {
  "&:hover": {
    color: "#fff",
  },
};

export { buttonsRowStyle, buttonAStyle };
